<template>
  <workspace-selection
    ref="tippyRef"
    shadow-label
    :active-workspace="activeWorkspace"
    @switch-workspace="switchWorkspace"
  />
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import WorkspaceSelection from '@/modules/shared/WorkspaceSelection.vue'
import { useWorkspaceList } from '@/composables/useWorkspaceList'
import usePromptTestingWorkspace from '@/modules/settings/composables/usePromptTestingWorkspace'

const emit = defineEmits<{
  'switch-workspace': [workspaceId: number]
}>()

const { activeWorkspace } = usePromptTestingWorkspace()

const tippyTemplateRef = useTemplateRef('tippyRef')

const [workspaces] = useWorkspaceList()

const switchWorkspace = (workspaceId: number) => {
  if (workspaceId === activeWorkspace.value?.id) return
  tippyTemplateRef.value?.tippyRef?.tip.hide()

  activeWorkspace.value = workspaces.value.find((ws) => ws.id === workspaceId)

  emit('switch-workspace', workspaceId)
}
</script>
